/**
 * @desc Yung-创建入库单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: defs.wms.InMasterCreateRequestRpcDto, options?: any) {
  return updateResponse(
    http(URL + `/rpc/inMaster/createInMaster`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
